import { CorePaymentMethod, Maybe } from "@oysterhr/schema"
import { Alert } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import LinkButton from "~/app/components/LinkButton"
import { isDeactivated } from "../utils"
interface DeactivationAlertProps {
  paymentMethod?: Maybe<CorePaymentMethod>
  onDelete: (paymentMethod: CorePaymentMethod) => void
}

export const DeactivationAlert = ({ paymentMethod, onDelete }: DeactivationAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts",
  })

  if (!paymentMethod || !isDeactivated(paymentMethod)) return null

  return (
    <Alert variation="error">
      <Alert.Icon />
      <Alert.Content>
        <p>{t("deactivation.content")}</p>
        <LinkButton
          className="!ml-0"
          emphasized
          onClick={() => onDelete(paymentMethod as CorePaymentMethod)}
        >
          {t("deactivation.action")}
        </LinkButton>
      </Alert.Content>
    </Alert>
  )
}
